import Phaser from 'phaser';

import { CardViewModel } from './card-view-model';
import { BlackjackMainScene } from '../../scenes/blackjack-main-scene';
import { ResizeMetrics } from '../../model/resize-metrics';

export class CardShadowView extends Phaser.GameObjects.Container {
  private cardShadow: Phaser.GameObjects.Image;

  constructor(
    scene: BlackjackMainScene,
    x: number,
    y: number,
    private viewModel: CardViewModel,
  ) {
    super(scene, x, y);

    this.cardShadow = scene.add.image(0, 0, viewModel.cardShadowAsset.type).setOrigin(0.5, 0.5);
    this.add(this.cardShadow);

    this.setName(CardShadowView.name);
    scene.add.existing(this);
  }

  public onResize(resizeMetrics: ResizeMetrics): void {
    const cardScaleFactor = resizeMetrics.scalingMetrics.scaleFactor * 0.8;

    const asset = this.viewModel.cardShadowAsset;
    this.cardShadow.setDisplaySize(
      asset.dimensions.width * cardScaleFactor,
      asset.dimensions.height * cardScaleFactor,
    );
  }
}
